import { createBrowserHistory } from "history";

const navigationHistory = createBrowserHistory();

export default navigationHistory;
